<template>
  <div class="app-container paper-list">
    <div class="paper-list-filter">
      <el-row>
        <el-col :span="18">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="8">
                <el-input class="paper-list-filter-value" v-model.trim="search.title" 
                  @keyup.enter.native="searchChange" placeholder="试卷名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
              </el-col>
              <el-col :span="8">
                <el-input class="paper-list-filter-value" v-model.trim="search.username" 
                  @keyup.enter.native="searchChange" placeholder="创建人" clearable size="small" suffix-icon="el-icon-search"></el-input>
              </el-col>
              <el-col :span="8">
                <el-select class="paper-list-filter-value" placeholder="类型" v-model="search.type" clearable size="small">
                  <el-option
                    v-for="item in paperTypeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="paper-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="paper-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container class = "paper-list-container">
      <avue-crud
          ref="crud"
          :option="tableOption"
          :data="tableData"
          :page="page"
          :table-loading="tableLoading"
          :before-open="handleOpenBefore"
          @refresh-change="getData"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange">

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.paper_add">创建试卷</el-button>
        </template>
        <template slot-scope="scope"
          slot="menu">
          <el-button size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button type="text"
            v-if="permissions.paper_edit"
            icon="el-icon-edit"
            size="mini"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.paper_del"
            icon="el-icon-delete"
            size="mini"
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { getPaperList, deletePaper } from '@/api/app/paper'
import { paperTableOption, paperTypeOption } from '@/const/crud/app/paper'
import { mapGetters } from 'vuex'

export default {
  name: 'paper',
  data() {
    return {
      tableOption: paperTableOption,
      paperTypeOption,
      search: {
        current: 1,
        size: 10,
        title: '',
        username: '',
        type: '',
      },
      // 列表页面
      tableData:[],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      tableLoading: false,
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }

      if (this.search.title != "" && this.search.title.trim() != "") {
        params.pname = this.search.title
      }
      if (this.search.username != "" && this.search.username.trim() != "") {
        params.username = this.search.username
      }
      if (!this.validatenull(this.search.type)) {
        params.ptype = this.search.type
      }
      if (this.validParams(params)) {
        this.tableLoading = true
        getPaperList(params).then(response => {
          this.tableData = response.data.data.records;
          this.tableData.forEach(record => {
            record.type = (paperTypeOption.find((v) => (v.value == record.type)) ? paperTypeOption.find((v) => (v.value == record.type)).label :'类型异常');
          })
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取试卷列表失败',
            type: 'error'
          })
          this.tableLoading = false;
        })
      }
    },
    validParams(params) {
      if (params.username && params.username.length < 2) {
        this.$message({
          message: '创建人至少输入两个字符',
          type: 'error'
        })
        return false;
      } 
      return true;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.search.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.search.size = val
      this.getList()
    },
    initPage() {
      this.page.currentPage = 1
      this.page.pageSize = this.search.size
      this.search.current = 1
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.title = '',
      this.search.username = '',
      this.search.type = '',
      this.searchChange()
    },
    handleAdd: function() {
      this.$router.push({
        path: '/app/exam/paper/add'
      })
    },
    handleEdit(row, index) {
      this.$router.push({
        path: `/app/exam/paper/edit/${row.id}`,
      })
    },
    handleView(row, index) {
      this.$router.push({
        path: `/app/exam/paper/show/${row.id}`,
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletePaper(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          }
        }).catch(error => {
          this.$message({
            message: error,
            type: 'error'
          })
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.paper-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
</style>
